import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class Site extends Vue {
  @Prop({ default: () => {} })
    value: NewDisplayShopInfo;

  @Prop({ default: false })
    disabled: boolean;

  @Prop()
    fromPage: number;

  data: NewDisplayShopInfo = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.data.desc.siteInfo.siteLogo = res.content;
  }

  render(h) {
    return (
      <div class="site">
        <el-form disabled={this.disabled}>
          <el-checkbox v-model={this.data.desc.isShow} true-label={1} false-label={0} disabled={this.disabled}>
            显示店铺信息
          </el-checkbox>
          <div class="cont no-scroll">{this?.value?.desc?.siteInfo?.siteLogo ? <Upload onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.data.desc.siteInfo.siteLogo} noDelete={false} maxSize={100} disabled={this.disabled} /> : ''}</div>
          {this.fromPage === 1 && <p class="tip blockTip r-mt-10">注1：&nbsp;此形象图将作为默认店铺LOGO，各店铺可自行修改；</p>}
          <p class="tip blockTip">注{this.fromPage === 1 ? 2 : 1}：&nbsp;建议图片分辨率为 150px*150px，不超过300k，必须为正方形;</p>
        </el-form>
      </div>
    );
  }
}
